import 'css-chunksrc/client/pages/utilityPage/projectPage/projectStatusesList/loader/styles.scss';export default {
  "statuses": "_statuses_n0fxz_1"
};